import get from 'lodash/get'
import React from 'react'
import type { RedirectProps } from 'react-router-dom'
import { Redirect } from 'react-router-dom'
import { useClientOptions, useUser, useUserPermissions } from '@paintscout/ui-business'

export interface RedirectHomeProps extends Omit<RedirectProps, 'to'> {}

/**
 * Redirects to either /dashboard or /quotes, depending on features & profile settings.
 * Painter accounts always redirect to /scheduling/painter.
 */
export default function RedirectHome(props: RedirectHomeProps) {
  const { options } = useClientOptions()
  const { profile, isPainter } = useUser()
  const { permissionToViewDashboard } = useUserPermissions()

  if (isPainter) {
    return <Redirect to="/scheduling/painter" {...props} />
  }

  const hasDashboard = get(options, 'options.features.dashboard.enabled', false) && permissionToViewDashboard
  const homePage = get(profile, 'preferences.homePage', hasDashboard ? 'dashboard' : 'quotes')
  const resolvedPage = homePage === 'dashboard' && !permissionToViewDashboard ? 'quotes' : homePage

  return <Redirect to={`/${resolvedPage}/`} {...props} />
}
